export const pages = {
	'news': { id: 'news', page: 'newsPage', getter: () => import(/* webpackChunkName: 'news' */ 'components/bolt/newsPage/newsPage') },
	'about': { id: 'about', page: 'about', getter: () => import(/* webpackChunkName: 'about' */ 'components/bolt/about/about') },
	'landing': { id: 'landing', page: 'landing', getter: () => import(/* webpackChunkName: 'landing' */ 'components/bolt/landing/landing') }
};
export const sections = [

];
export const sectionsWithParent = [

];
